import React, {
  useCallback,
  useEffect,
  useMemo,  
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import {
  caseDetailDataGridLocalStorageKeyName,
  caseListCommonColumns,
  deleteExternalAuditCase,
  emdrCaseDetailDataGridLocalStorageKeyName,
} from "../../pages/external-audit/case-list/case-list-detail";
import {
  REMOVE_CURRENT_SELECTED_CASE_IDS,
  SET_CURRENT_SELECTED_CASE_IDS,
} from "./reducers/ea-case-fields-reducer";
import { Selection } from "devextreme-react/data-grid";
import {
  SET_VIEW_COMPONENT_LINE_ITEMS,
  TOGGLE_CASE_LIST_DETAIL_ACTION_POPOVER  
} from "../../pages/external-audit/case-list/reducers/case-list-reducer";
import MdaeDataGrid, { IMdaeDataGridProps } from "../common_widgets/data-grid";
import MdaeActionPopover from "../common_widgets/menu-action-popover";
import { toggleCaseDetailPopup } from "../../pages/external-audit/case-detail/case-detail-common-functions";
import { isManualCase } from "../../pages/external-audit/case-detail/component";
import dxDataGrid from "devextreme/ui/data_grid";
import { first, isEqual, update } from "lodash";
import {  
  FG_EXTERNAL_AUDIT_CREATION,
  getUserPermissionObject,
  hasAnyFeatureGroupAccess
} from "../user-permissions-helper";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
} from "../mdae-common-reducer";
import {
  SET_ESMD_SUBMISSION_LIST,
  SET_REFRESH_AUDIT_SUMMARY_DATA,
} from "../../pages/external-audit/reducers/external-audit-reducer";
import { callOperation } from "async-ops";
import { GET_ESMD_SUBMISSION_BY_AUDIT_ID } from "../../pages/external-audit/services/get-esmd-submission-by-audit-id";
import {
  ADD_MANUAL_CASE_POPUP_MODES,
  setAddCaseManualPopupData,
  setManualCaseSaveButtonDisabledProperty,
  toggleAddCaseManualPopup,
} from "../add-case-manual/component";
import {
  formatManualCaseObjectForView,
  initialAddCasweManualFormData,
} from "../add-case-manual/reducer/add-case-manual-reducer";
import { addCaseManualPopupTitles } from "../add-case-manual/constant";
import { GET_MANUAL_CASE_DETAIL_BY_ID } from "../add-case-manual/services/get-manual-case-detail-by-id";
import { SET_AUDIT_PROPERTIES_DATA } from "../../pages/external-audit/reducers/audit-properties-reducer";
import { AUDIT_LIST_TYPE } from "../../pages/emdr-inbox/constant";
import { CASE_LIST_TYPES } from "../../pages/external-audit/case-list/constants";
const caseListGridId = "pnlCaseListGrid";
const deleteAuditCaseMessage = "Are you sure you want to delete this case?";
interface IEACaseDetail {
  data?: any;
  hideSelection: boolean;
  type: string;
}

const EACaseDetail: React.FC<IEACaseDetail> = (props) => {
  const dispatch = useDispatch();
  const { hideSelection, type } = props;
  const auditCasesList = (props && props?.data?.data.auditCasesList) || []; // Fallback to empty array if no claims

  const caseListRowPrepared = useCallback((e) => {
    if (e.rowType === "data" && e.columnIndex === 1) {
      $(e.cellElement).addClass(
        "case-detail-datagrid-cell-" + e.data?.eaCaseId
      );
    }
  }, []);

  const [caseDetailDataGridInstance, setCaseDetailDataGridInstance] = useState<
    dxDataGrid
  >(null);
  const getCurrentSelectedRowData: any = () => {
    return first(caseDetailDataGridInstance?.getSelectedRowsData());
  };

  const toggleCaseListDetailActionPopover = useCallback(
    (isVisible, target, otherConfig = null) => {
      dispatch({
        type: TOGGLE_CASE_LIST_DETAIL_ACTION_POPOVER,
        data: {
          caseListDetailDataGidActionPopoverTarget:
            ".case-detail-datagrid-cell-" +
            otherConfig?.currentRowData?.eaCaseId,          
          [`isCaseDetailPopoverVisible${props?.data?.data?.eaAuditId}`]: isVisible,
        },
      });
    },
    [props?.data?.data?.eaAuditId]
  );

  const eaCaseDetailProperties = useMemo(() => {
    return getEACaseDetailGridOptions(
      dispatch,
      toggleCaseListDetailActionPopover,
      type,
      setCaseDetailDataGridInstance,
      props?.data?.data?.eaAuditId
    );
  }, [
    dispatch,
    toggleCaseListDetailActionPopover,
    type,
    props?.data?.data?.eaAuditId,
  ]);

  const selectedCaseDetailIdsToAttachDocument = useSelector(
    (state) =>
      state["eacaseFieldsReducer"].selectedCaseDetailIdsToAttachDocument
  );
  const onCaseListMasterDatagridSelectionChanged = useCallback((e) => {
    if (e.currentSelectedRowKeys?.length > 0)
      dispatch({
        type: SET_CURRENT_SELECTED_CASE_IDS,
        data: e.currentSelectedRowKeys,
      });

    if (e.currentDeselectedRowKeys?.length > 0)
      dispatch({
        type: REMOVE_CURRENT_SELECTED_CASE_IDS,
        data: e.currentDeselectedRowKeys,
      });
  }, []);

  return (
    <div>
      <CaseDetailPopover
        toggleCaseListDetailActionPopover={toggleCaseListDetailActionPopover}
        data={props}
        getCurrentSelectedRowData={getCurrentSelectedRowData}
        type={type}
        caseListType={CASE_LIST_TYPES.FROM_AUDIT}
      />
      <div className="grid-container">
        <MdaeDataGrid
          {...eaCaseDetailProperties}
          dataSource={auditCasesList}
          {...(type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE && {
            onSelectionChanged: onCaseListMasterDatagridSelectionChanged,
            selectedRowKeys: selectedCaseDetailIdsToAttachDocument,
          })}
          {...(type?.toUpperCase() !== AUDIT_LIST_TYPE.EMDR_TYPE && {
            onCellPrepared: caseListRowPrepared,
          })}
          keyExpr="eaCaseId"
        >
          {!hideSelection && (
            <Selection
              mode="multiple"
              showCheckBoxesMode="always"
              allowSelectAll={false}
            />
          )}
        </MdaeDataGrid>
      </div>
    </div>
  );
};
const getEACaseDetailGridOptions = (
  dispatch,
  toggleCaseListDetailActionPopover,
  type,
  setCaseDetailDataGridInstance,
  eaAuditId,
  
) => {
  const EACaseDetailGridOptions: IMdaeDataGridProps = {
    id: caseListGridId + eaAuditId,
    columnChooser: { enabled: type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE ? false : true },
    filterRow: { visible: true },
    showColumnLines: true,
    onInitialized: (e) => {
      setCaseDetailDataGridInstance(e.component);
    },
    stateStoring: {
      enabled: true,
      type: "localStorage",
      storageKey: type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE ?emdrCaseDetailDataGridLocalStorageKeyName:caseDetailDataGridLocalStorageKeyName,
    },
    onRowDblClick: function(e) {
      toggleCaseListDetailActionPopover(false, null);
        toggleCaseDetailPopup(
          dispatch,
          true,
          "Audit Case Details",
          e.data,
          0
        );
    },
    mdaeColumns: [
      ...caseListCommonColumns(
        "perm",
        true,
        dispatch,
        toggleCaseListDetailActionPopover,
        type
      ),
    ],
  };
  return EACaseDetailGridOptions;
};

const getGroupRowDataRecursively = (data) => {
  const firstKey: any = first(data);
  if (firstKey?.key) {
    return getGroupRowDataRecursively(firstKey?.items);
  } else {
    return data;
  }
};
interface ICaseDetailPopoverProps {
  toggleCaseListDetailActionPopover: (
    isVisible: boolean,
    target: any,
    otherConfig?: any
  ) => void;
  data?: any;
  getCurrentSelectedRowData?: () => any;
  type: string;
  caseListType: string;
  refreshCasesList?: () => void;
}
export const CaseDetailPopover: React.FC<ICaseDetailPopoverProps> = (props) => {  
  const dispatch = useDispatch();

  const auditPropertiesData = useSelector(
    (state: any) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const hasAuditCreateAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_EXTERNAL_AUDIT_CREATION], currentUser),
    [currentUser]
  );
  const isExternalAuditReadOnly = useSelector(
    (state) => state["auditPropertiesReducer"].isExternalAuditReadOnly,
    isEqual
  );

  const isDocumentManagementEnabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentManagementEnabled,
    isEqual
  );
  const eaAuditRounds = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds,
    isEqual
  );
  const esmdSubmissionListForAudit = useSelector(
    (state) => state["externalAuditReducer"].esmdSubmissionListForAudit,
    isEqual
  );

  const showchkbxViewCmpntFromReducer = useSelector(
    (state) => state["caseListReducer"].isShowChkbxViewCmpnt
  );

  useEffect(() => {
    const sessionValue = window.sessionStorage.getItem(
      auditPropertiesData?.eaAuditId + "PAW"
    );
    const sessionStorageValue =
      sessionValue && sessionValue !== "undefined"
        ? JSON.parse(sessionValue)
        : false;

    if (sessionStorageValue !== showchkbxViewCmpntFromReducer) {
      dispatch({
        type: SET_VIEW_COMPONENT_LINE_ITEMS,
        data: { isShowChkbxViewCmpnt: sessionValue },
      });
    }
  }, [auditPropertiesData?.eaAuditId, showchkbxViewCmpntFromReducer]);

  const auditCasePermission = getUserPermissionObject(
    "AUDIT_CASE",
    currentUser
  );
  useEffect(() => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: props?.data?.data?.data,
      },
    });
  }, [props?.data?.data?.data?.eaAuditId]);

  const hideConfirmationPopup = useCallback(() => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  }, []);

  const showConfirmationPopup = useCallback(
    (message) => {
      dispatch({
        type: TOGGLE_CONFIRMATION_POPUP,
        data: {
          onConfirm: () => {
            deleteExternalAuditCase(
              props.getCurrentSelectedRowData(),
              dispatch,
              props.caseListType,
              props.refreshCasesList
            ).then(() => {
              hideConfirmationPopup();
              dispatch({
                type: SET_REFRESH_AUDIT_SUMMARY_DATA,
                data: true,
              });
            });
            if (
              eaAuditRounds[0]?.rqstrRecordSubmissionMethod?.toLowerCase() ==
                "esmd" ||
              esmdSubmissionListForAudit?.length > 0
            ) {
              callOperation(GET_ESMD_SUBMISSION_BY_AUDIT_ID, {
                auditId: auditPropertiesData?.eaAuditId,
              }).then((response) => {
                dispatch({
                  type: SET_ESMD_SUBMISSION_LIST,
                  data: {
                    esmdSubmissionListForAudit: Array.isArray(response)
                      ? response
                      : [],
                  },
                });
              });
            }
          },
          visible: true,
          confirmShown: true,
          declineShown: true,
          width: 380,
          height: 200,
          contentHtml: message,
          onDecline: hideConfirmationPopup,
        },
      });
    },
    [
      eaAuditRounds,
      esmdSubmissionListForAudit,
      auditPropertiesData?.eaAuditId,
      dispatch,
      hideConfirmationPopup,
      props.getCurrentSelectedRowData,
    ]
  );

  const toggleConfirmationPopupVisible = useCallback(
    (isVisible, message) => {
      if (isVisible) {
        showConfirmationPopup(message);
      } else {
        hideConfirmationPopup();
      }
    },
    [showConfirmationPopup, hideConfirmationPopup]
  ); 

  const caseListDetailActionPopoverMenuList = () => [
    {
      text: "View Case",
      icon: () => {
        return (
          <div
            style={{ height: "14px" }}
            className={"preview-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        props.toggleCaseListDetailActionPopover(false, null);
        toggleCaseDetailPopup(
          dispatch,
          true,
          "Audit Case Details",
          props.getCurrentSelectedRowData(),
          0
        );
      },
    },
    {
      text: "Edit Case",
      visible: isManualCase(props.getCurrentSelectedRowData())&& props.type?.toUpperCase() === AUDIT_LIST_TYPE.CASE_LIST,
      disabled: isExternalAuditReadOnly || !auditCasePermission?.hasAddAccess,
      icon: () => {
        return (
          <div
            style={{ height: "14px" }}
            className={"create-new-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        props.toggleCaseListDetailActionPopover(false, null);
        dispatch({ type: SHOW_LOADER });       
        toggleAddCaseManualPopup(
          dispatch,
          true,
          null,
          addCaseManualPopupTitles.UPDATE,
          ADD_MANUAL_CASE_POPUP_MODES.UPDATE
        );        
        setTimeout(() => {
          setAddCaseManualPopupData(dispatch, initialAddCasweManualFormData);
        }, 100);

        callOperation(
          GET_MANUAL_CASE_DETAIL_BY_ID,
          props.getCurrentSelectedRowData()?.eaCaseId
        ).then((response) => {
          dispatch({ type: HIDE_LOADER });
          setAddCaseManualPopupData(dispatch, {
            claimTypeCd: response.claimTypeCd,
            patientType: response?.patientType,
          });
          setTimeout(() => {
            setAddCaseManualPopupData(
              dispatch,
              formatManualCaseObjectForView(response)
            );
          }, 100);
        });
        setManualCaseSaveButtonDisabledProperty(dispatch, false);
      },
    },
    {
      text: "Tasks",
      icon: () => {
        return <div style={{ height: "14px" }} className={"task-icon"}></div>;
      },
      onClick: () => {
        props.toggleCaseListDetailActionPopover(false, null);
        toggleCaseDetailPopup(
          dispatch,
          true,
          "Audit Case Details",
          props.getCurrentSelectedRowData(),
          1
        );
      },
    },
    {
      text: "Documents",
      visible: isDocumentManagementEnabled,
      icon: () => {
        return <div style={{ height: "14px" }} className={"upload-icon"}></div>;
      },
      onClick: () => {
        props.toggleCaseListDetailActionPopover(false, null);
        toggleCaseDetailPopup(
          dispatch,
          true,
          "Audit Case Details",
          props.getCurrentSelectedRowData(),
          2
        );
      },
    },
    {
      text: "Delete Case",
      visible: hasAuditCreateAccess && props.type?.toUpperCase() === AUDIT_LIST_TYPE.CASE_LIST,
      disabled: isExternalAuditReadOnly,
      icon: () => {
        return (
          <div
            style={{ height: "16px" }}
            className={"delete-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        props.toggleCaseListDetailActionPopover(false, null);
        toggleConfirmationPopupVisible(true, deleteAuditCaseMessage);
      },
    },
  ];

  const UpdaterConfig = useMemo(() => {
    const auditId = props?.data?.data?.data?.eaAuditId;
    return [
      {
        actionType: TOGGLE_CASE_LIST_DETAIL_ACTION_POPOVER,
        reducerName: "caseListReducer",
        widgetOptionBindings: {
          target: "caseListDetailDataGidActionPopoverTarget",
          visible: `isCaseDetailPopoverVisible${auditId}`,
        },
      },
    ];
  }, [props?.data?.data?.data?.eaAuditId]);

  return (
    <MdaeActionPopover
      mdaePopoverConfig={{
        id: "pnlCaseListDetailActionPopover",
        mdaeDataUpdaterConfig: UpdaterConfig,
      }}
      menuItemListFunction={caseListDetailActionPopoverMenuList}
    ></MdaeActionPopover>
  );
};

export default EACaseDetail;
